import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, Renderer2 } from '@angular/core';

@Component({
    standalone: false,
    selector: 'cut-down-content',
    template: `
        <div id="wrap"
             matTooltip="{{textInput}}"
             [matTooltipDisabled]="textInput.length < length">
            <ng-content></ng-content>
        </div>`,
    styleUrls: ['./cut-down-content.component.scss']

})
export class CutDownContentComponent implements AfterViewInit {
    @Input() length: number;
    public textInput = '';

    constructor(private elementRef: ElementRef,
                private renderer: Renderer2,
                private changeDetectorRef: ChangeDetectorRef) {
    }

    ngAfterViewInit() {
        const div = this.elementRef.nativeElement.querySelector('#wrap');
        this.textInput = div.childNodes[0].nodeValue;
        this.renderer.setValue(div.childNodes[0], this.textInput.length > this.length ? this.textInput.slice(0, this.length) + '...' : this.textInput);
        this.changeDetectorRef.detectChanges();
    }
}
